// COPIA da TMA#718 di CriGio @ 8e60f982: src/components/burraco/PalcoScalato.tsx — CAMBI: la misura del palco e' una prop (nell'originale erano PALCO_W e PALCO_H importate da TavoloStage, che e' del burraco); l'import di useScala.
import { useScala } from '@/lib/tavolo/useScala';

/**
 * Il palco `larghezza` x `altezza` scalato alla larghezza che la pagina ha. Il raggio sta nel palco, in unita di disegno: scala con lui. Sul
 * contenitore (fuori dalla scala) a 0,42 ritagliava l'angolo del titolo (B5-1bis). Il contenitore misura e ritaglia, il palco scala.
 */
export function PalcoScalato({ larghezza, altezza, children }: { larghezza: number; altezza: number; children: React.ReactNode }) {
  const { ref, scala } = useScala(larghezza);
  return (
    <div ref={ref} className="w-full overflow-hidden" style={{ height: altezza * scala }}>
      <div data-palco-scala={scala} style={{ width: larghezza, height: altezza, transform: `scale(${scala})`, transformOrigin: 'top left' }}>
        {children}
      </div>
    </div>
  );
}
